import { wgs2gcjForObject, isEqual } from '@/util/map'
import { datetime } from '@/util'
import { moment } from '@/util'

const timeDisplay = (d) => {
  if(d.ruleType == 0){
    d.ruleText = '长期有效'
  }else if(d.ruleType == 1){
    d.ruleText = moment(d.ruleBegindate,'yyyy-MM-dd')+' ~ '+moment(d.ruleEnddate,'yyyy-MM-dd')
  }

  if(d.cycleRule == 1){
    d.cycleText = '仅法定工作日'
  }

  d.cycleTimeText = d.cycleTime.map(i => `${i.beginTime} - ${i.endTime}`)

  return d
}

export default {
  props: [ 'data' ],
  data(){
    return {
      fenceData:{}
    }
  },
  created(){
    this.$watch('data' , function(nv){
      if(nv){
        this.setData(nv)
      }
    } , {immediate:true})
  },
  methods:{
    setData(d){
      d = this.$utils.conv(d,{gfType:'fenceType' , 'alarm':'fenceAlarm' , 'cycleRule':'fenceCycleRule','status':'enable'})
      console.log(d)
      d = timeDisplay(d)
      d.cycleTime = d.cycleTime.map( i => ([i.beginTime , i.endTime]))
      this.fenceData = d
    },
    handleClose(){
      this.$emit('close')
    }
  },
  render() {
    const data = this.fenceData

    return (
      <div class="db-map-fence-detail">
        <sl-spin loading={!!data ? false : true}>
        <div class="car-map-detail-hd">
          <div class="car-map-detail-close" on-click={this.handleClose}><Icon size={18} type="md-close" /></div>
          <div class="car-map-detail-hd-title">{data.gfName}</div>
          <p>{data.gfTypeText}</p>
        </div>
        <div class="car-map-detail-bd">
          <sl-detail-list label-width="100px" col={1} label-align="right">
          
            <sl-detail-list-item label="机构">{data.orgName}</sl-detail-list-item>

            <sl-detail-list-item label="生效时间">{data.ruleText}</sl-detail-list-item>
            <sl-detail-list-item label="循环周期">
              <div>{data.cycleText}</div>
              <div>{(data.cycleTimeText || []).join('; ')}</div>
            </sl-detail-list-item>
            <sl-detail-list-item label="报警类型">{data.alarmText}</sl-detail-list-item>
            <sl-detail-list-item label="状态">{data.statusText}</sl-detail-list-item>
            <sl-detail-list-item label="备注">{data.remark}</sl-detail-list-item>
          </sl-detail-list>
        </div>
        </sl-spin>
      </div>
    )
  }
}